export default "__VITE_ASSET__BQhnWhHe__"